'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBoxObjectSelector', ['$controller', function ($controller) {
      return {
        templateUrl: 'views/directives/notes/saNoteQueryBoxObjectSelector.html',
        restrict: 'A',
        scope: {
          managementId: '@'
        },
        controller: ['$scope', 'PositionsStore', 'UsersStore', function($scope, PositionsStore, UsersStore) {
          $scope.state = {
            queryData: {
              obj: null,
              obj_id: null
            },
            typeSelected: false,
            idSelected: false
          };

          $scope.dropdownState = {
            display: 'N/A'
          };

          $scope.autocompleteState = {
            data: null,
            output: null
          };

          function getLabel(type, obj) {
            if (type === 'Position') {
              return obj.name;
            } else if (type === 'User') {
              return obj.first_name + ' ' + obj.last_name;
            } else {
              return '';
            }
          }

          $scope.clearSelection = function(type) {
            $scope.autocompleteState.output = null;
            $scope.state.idSelected = false;
            $scope.state.queryData.obj_id = null;

            if (type === 'full') {
              $scope.dropdownState.display = 'N/A';
              $scope.state.typeSelected = false;
              $scope.state.queryData.obj = null;
            }

          };

          $scope.objectTypes = {
            'Position': {
              getAll: PositionsStore.getAll
            },
            'User': {
              getAll: UsersStore.getAll
            }
          };

          $scope.clickType = function(key) {
            console.log('Selecting ' + key + ' as Object Type');

            // This means N/A was selected
            if (key === undefined) {
              $scope.clearSelection('full');
              return;
            }

            $scope.dropdownState.display = key;
            $scope.state.typeSelected = true;
            $scope.state.idSelected = false;
            $scope.state.queryData.obj = key;

            var selection = $scope.objectTypes[key];
            selection.getAll()
              .then(function(list) {
                $scope.autocompleteState.data = [];
                _.each(list, function(obj) {
                  $scope.autocompleteState.data.push({
                    label: getLabel(key, obj),
                    obj: obj
                  });
                });
              }, function(response) {
                console.log('Failed to retrieve list of ' + key + ' Objects');
              });
          };

          $scope.$watch('autocompleteState.output', function(newVal, oldVal) {
            if (newVal !== oldVal && newVal !== null) {
              $scope.state.idSelected = true;
              $scope.state.queryData.obj_id = $scope.autocompleteState.output.originalObject.obj.id;
            }
          });
        }],
        link: function(scope) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          var unwatch = null;
          var watch = function() {
            scope.execution = false;
            unwatch = scope.$watch('[state.queryData.obj, state.queryData.obj_id]', function(newVal, oldVal) {
              for (var i = 0; i < 2; i++) {
                newVal[i] = (newVal[i] == undefined) ? null : newVal[i];
                oldVal[i] = (oldVal[i] == undefined) ? null : oldVal[i];
              }
              if (newVal !== oldVal && scope.execution) {
                throttledUpdate();
              }
            });
            scope.execution = true;
          };

          watch();
          var throttledUpdate = _.throttle(function() {
            unwatch();
            var q = baseCtrl.getQuery();
            q.obj = (scope.state.typeSelected) ? scope.state.queryData.obj : 'date';
            q.obj_id = (scope.state.idSelected) ? scope.state.queryData.obj_id : null;
            q.custom = true;
            baseCtrl.setQuery(q);

            watch();
          }, 250);


          var update = function(currentQuery) {
            if (currentQuery.obj === 'WorkPeriod') {
              return;
            }

            unwatch();

            scope.state.queryData.obj = (currentQuery.obj != 'date') ? currentQuery.obj : null;
            scope.state.queryData.obj_id = currentQuery.obj_id;

            scope.state.typeSelected = (scope.state.queryData.obj && scope.state.queryData.obj != 'date');
            scope.dropdownState.display = (scope.state.typeSelected) ? scope.state.queryData.obj : 'N/A';
            scope.state.idSelected = !!scope.state.queryData.obj_id;

            watch();
          };

          // Base ctrl
          baseCtrl.initialize('QueryBoxObjectSelector', scope.managementId);
          baseCtrl.setRenderCallback(update);
          baseCtrl.updateMyself();
        }
      }
    }]);
